<template>
  <gd-modal
    ref="upgradeModal"
    name="upgrade"
    :title="$t('frontend_groovevideo_videos_index_upgrade_to_pro_today')"
  >
    <div class="flex flex-col items-center justify-center p-6">
      <p
        class="
          text-md
          leading-tight leading-loose
          mb-4
          text-grey-800 text-center
        "
        v-html="$t('frontend_upgrade_message')"
      ></p>
      <div class="flex flex-col items-center justify-center">
        <a
          @click="goToUpgradePage"
          target="_blank"
          class="
            flex
            items-center
            px-6
            py-3
            heading-sm
            focus:outline-none
            shadow
            hover:shadow-lg
            focus:shadow-lg
            rounded-lg
            bg-green-extra-dark
            text-white
            border-green-extra-dark border border-solid
            text-lg
            hover:bg-green-dark
          "
        >
          {{ $t('frontend_groovevideo_videos_index_see_all') }}
        </a>
        <button class="mt-4 outline-none" @click="$refs.upgradeModal.close()">
          {{ $t('frontend_groovevideo_videos_index_nothanks') }}
        </button>
      </div>
    </div>
  </gd-modal>
</template>

<script>
import upgradeHelper from '@/mixins/upgradeHelper.js';

export default {
  mixins: [upgradeHelper],
  methods: {
    open() {
      this.$refs.upgradeModal.open();
    },
  },
};
</script>
